module.exports = __webpack_public_path__ + "img/fi-rr-letter-case.4f4719e0.svg";